import type { PropsWithChildren } from 'react';
import React from 'react';

import Homepage from '../views/Homepage/Homepage';
import PageLayout from '../views/Layout/Page';
import { TPrefix } from '../views/Translate';

export function Index({ children }: PropsWithChildren<unknown>) {
  return (
    <PageLayout pageview="homepage">
      <TPrefix name="homepage">
        <Homepage />
        {children}
      </TPrefix>
    </PageLayout>
  );
}

export default function IndexPage() {
  return <Index />;
}
